module.exports = "/_next/static/images/mobilelending-e7fb876e42369bdcdd3b6592fe6c70ee.svg";